export const PRINT_MIRROR_CLASS = 'sv-print-mirror'
const MIRRORED_ATTR = 'data-print-mirrored'
// Native form controls clip their content when printed, so both multiline (textarea) and
// single-line (text input) answers get a plain block mirror that can wrap and grow.
export const PRINT_MIRROR_SELECTOR = '.sv_main textarea, .sv_main input[type="text"]'

const resolveDoc = root => {
  if (!root) return null
  if (typeof root.createElement === 'function') return root
  return root.ownerDocument || null
}

export const createPrintMirrors = (root = typeof document !== 'undefined' ? document : null) => {
  const doc = resolveDoc(root)
  if (!root || !doc || typeof root.querySelectorAll !== 'function') return 0

  const fields = root.querySelectorAll(PRINT_MIRROR_SELECTOR)
  let created = 0

  fields.forEach(field => {
    if (field.getAttribute(MIRRORED_ATTR) === 'true') return

    const parent = field.parentNode
    if (!parent) return

    const mirror = doc.createElement('div')
    mirror.className = PRINT_MIRROR_CLASS
    const value = field.value != null ? field.value : field.textContent
    mirror.textContent = value || ''

    parent.insertBefore(mirror, field.nextSibling)
    field.setAttribute(MIRRORED_ATTR, 'true')
    created += 1
  })

  return created
}

export const removePrintMirrors = (root = typeof document !== 'undefined' ? document : null) => {
  if (!root || typeof root.querySelectorAll !== 'function') return 0

  const mirrors = root.querySelectorAll('.' + PRINT_MIRROR_CLASS)
  let removed = 0

  mirrors.forEach(mirror => {
    if (mirror.parentNode) mirror.parentNode.removeChild(mirror)
    removed += 1
  })

  root.querySelectorAll('[' + MIRRORED_ATTR + ']').forEach(el => el.removeAttribute(MIRRORED_ATTR))

  return removed
}
